// ページトップ
function PageTopButton() {
  const pageTopButton = document.querySelector('.page-top');

  function handleScroll() {
    pageTopButton.style.opacity = window.pageYOffset > 600 ? '1' : '0';
  }

  window.addEventListener("scroll", handleScroll);
}

// モーダル
function modalOpen() {
  const modals = document.querySelectorAll(".modal-content");

  function openModal() {
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    document.body.style.overflow = '';
  }

  document.body.addEventListener("click", function(event) {
    const target = event.target;
    if (target.classList.contains("modal-open")) {
      event.preventDefault();
      const targetModalId = target.getAttribute("data-modal");
      const targetModal = document.getElementById(targetModalId);
      if (targetModal) {
        targetModal.style.display = targetModal.classList.contains('modal-block') ? "block" : "flex";
        openModal();
      }
    } else if (target.classList.contains("modal-content__inner-close") || target.classList.contains("js-close")) {
      const modal = target.closest(".modal-content");
      if (modal) {
        modal.style.display = "none";
        closeModal();
      }
    }
  });
}

// ギフトアコーディオンPC時開いておく
function initAccordion() {
  const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  if (windowWidth >= 700) {
    const elements = document.querySelectorAll('.accordion--gift');
  
    elements.forEach(function(element) {
      element.open = true;
    });
  }
}

// 商品詳細続きを見る
function moreView() {
  const elements = document.querySelectorAll('.detail__more-content');

  if (elements.length > 0) {
    for (const el of elements) {
      const btn = el.querySelector('.detail__more-content__button');
      const content = el.querySelector('.detail__more-content__inner');
      const defaultHeight = (window.innerWidth >= 700) ? 165 : 150;
      if (content.offsetHeight < defaultHeight) {
        btn.style.display = 'none';
        content.classList.add('is_allShow');
      }
      btn.addEventListener('click', function(){
        if(!content.classList.contains('is_open')){
          content.style.maxHeight = content.scrollHeight + 'px';
          content.classList.add('is_open');
          btn.querySelector('.text').textContent = '閉じる';
        } else {
          content.style.maxHeight = defaultHeight + 'px';
          content.classList.remove('is_open');
          btn.querySelector('.text').textContent = '続きを読む';
        }
      });
    }
  }
}

// パスワード表示・非表示切り替え
function passwordChange() {
  const passwordToggles = document.querySelectorAll('.toggle-icon');

  passwordToggles.forEach(passwordToggle => {
    passwordToggle.addEventListener('click', () => {
      const input = passwordToggle.previousElementSibling;
      const type = input.getAttribute('type');
      input.setAttribute('type', type === 'password' ? 'text' : 'password');
      passwordToggle.classList.toggle('is-show');
      const newTitle = type === 'password' ? 'パスワードを非表示にする' : 'パスワードを表示する';
      passwordToggle.setAttribute('title', newTitle);
    });
  });
}

// ヘッダーメニュークリック後ヘッダーメニューを強制的に閉じる
function headerMenu() {
  const menuListAll = document.querySelectorAll('.header__dropdown-menu li a');
  menuListAll.forEach((menuList,i)=>{
    menuList.addEventListener('click',(e)=>{
      const menu = e.target.closest('[aria-expanded]');
      menu.setAttribute('aria-expanded','false');
      menu.removeAttribute('open');
    });
  });
}

// カテゴリリストもっと見る開閉
function categoryList() {
  const moreContents = document.querySelector('.js-more__contents');
  const moreButton = document.querySelector('.js-more__button');
  const moreButtonText = document.querySelector('.js-more__button .label');

  if (moreButton) {
    moreButton.addEventListener('click', function () {
      const isOpen = moreContents.classList.contains('is_open');

      if (!isOpen) {
        moreButtonText.textContent = '閉じる';
        moreContents.classList.add('is_open');
        moreButton.classList.add('is_open');
      } else {
        moreButtonText.textContent = 'もっと見る';
        moreContents.classList.remove('is_open');
        moreButton.classList.remove('is_open');
      }
    });
  }
}

// 追従調整
function stickyPosition() {
  function updateStickyStyles() {
    const productSticky = document.querySelector('.product-sticky-bar');
    const productStickyHeight = productSticky ? productSticky.clientHeight : 0;
    const contentsSticky = document.getElementById('hulk_cookie_bar');
    const contentsStickyHeight = contentsSticky ? contentsSticky.clientHeight : 0;

    const totalStickyHeight = productStickyHeight + contentsStickyHeight;

    const pageTop = document.querySelectorAll('.page-top');

    pageTop.forEach((element) => {
      if (productSticky && contentsSticky) {
        productSticky.style.setProperty('inset-block-end', contentsStickyHeight + 'px');
        element.style.bottom = totalStickyHeight + 'px';
      } else if (productSticky) {
        element.style.bottom = productStickyHeight + 'px';
      } else if (contentsSticky) {
        element.style.bottom = contentsStickyHeight + 'px';
      }
    });
  }

  updateStickyStyles();

  const cookieButtons = document.querySelectorAll('#hulk_cookie_bar .button_div button');
  cookieButtons.forEach((button) => {
    button.addEventListener('click', () => {
      setTimeout(() => {
        updateStickyStyles();
      }, 1000);
    });
  });
}

// header-event
function headerEvent() {
  const headerHeight = 30;
  const winScrollTop = window.pageYOffset || document.documentElement.scrollTop;
  const isHeaderHidden = winScrollTop >= headerHeight;

  const headerEventElement = document.querySelector('.header-event');
  if (headerEventElement) {
    if (winScrollTop === 0) {
      headerEventElement.classList.remove('is_hide');
    } else if (!headerEventElement.classList.contains('is_hide')) {
      headerEventElement.classList.toggle('is_hide', isHeaderHidden);
    }
  }
}

window.addEventListener("scroll", headerEvent);

let loadEventFired = false;

window.addEventListener('load', function() {
  // 重複実行を防ぐ
  if (loadEventFired) return;
  loadEventFired = true;

  PageTopButton();
  modalOpen();
  initAccordion();
  moreView();
  passwordChange();
  headerMenu();
  categoryList();
  stickyPosition();
  headerEvent();
});

window.addEventListener('resize', function() {
  initAccordion();
  stickyPosition();
  headerEvent();
});